import { atom } from "recoil"
import { UserDetail } from "../connector/type";

const userDetailsStateDefault: Map<string, UserDetail> = new Map<string, UserDetail>();

const userDetailsState = atom({
  key: 'userDetails',
  default: userDetailsStateDefault,
});

export default userDetailsState;